/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './diag-lab.reducer';

export const DiagLabDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const diagLabEntity = useAppSelector(state => state.diagLab.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="diagLabDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.diagLab.detail.title">DiagLab</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.diagLab.id">Id</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.id}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.diagLab.name">Name</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.name}</dd>
          <dt>
            <span id="createdDtm">
              <Translate contentKey="tinyMedicRestApp.diagLab.createdDtm">Created Dtm</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.createdDtm}</dd>
          <dt>
            <span id="createdBy">
              <Translate contentKey="tinyMedicRestApp.diagLab.createdBy">Created By</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.createdBy}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.diagLab.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.timestampEntry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.diagLab.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.microSec}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.diagLab.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.lastUpdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.diagLab.active">Active</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.diagLab.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.cursor}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.diagLab.email">Email</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.email}</dd>
          <dt>
            <span id="taxCode">
              <Translate contentKey="tinyMedicRestApp.diagLab.taxCode">Tax Code</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.taxCode}</dd>
          <dt>
            <span id="billPrefix">
              <Translate contentKey="tinyMedicRestApp.diagLab.billPrefix">Bill Prefix</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.billPrefix}</dd>
          <dt>
            <span id="ownPanels">
              <Translate contentKey="tinyMedicRestApp.diagLab.ownPanels">Own Panels</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.ownPanels ? 'true' : 'false'}</dd>
          <dt>
            <span id="labServiceType">
              <Translate contentKey="tinyMedicRestApp.diagLab.labServiceType">Lab Service Type</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.labServiceType}</dd>
          <dt>
            <span id="description">
              <Translate contentKey="tinyMedicRestApp.diagLab.description">Description</Translate>
            </span>
          </dt>
          <dd>{diagLabEntity.description}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLab.user">User</Translate>
          </dt>
          <dd>{diagLabEntity.user ? diagLabEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.diagLab.contactCode">Contact Code</Translate>
          </dt>
          <dd>{diagLabEntity.contactCode ? diagLabEntity.contactCode.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/diag-lab" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/diag-lab/${diagLabEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DiagLabDetail;
